<template>
<app>
  <!--print button-->
  <a href="javascript:;" class="r5 button_print btn_green">Print</a>
  <div class="main">
    <div class="content">
      <!--header-->
      <div class="header clearfix">
        <div class="avatar">
          <a href="javascript:;" class="avatar_pic circle"><em class="circle doing">Detailed</em></a>
          <b class="doing r5">Man</b>
        </div>
        <div class="base">
          <p class="desc">Hello my name is</p>
          <h2>Brandon Pinto</h2>
          <p>Learning / engaged in the industry</p>
          <span>
            <p><i aria-hidden="true" class="icon_pin_alt"></i>Currently in Georgia</p>
            <p><a href="javascript:;" class="tel_me"><i aria-hidden="true" class="icon_mobile"></i>Contact Me</a></p>
          </span>
        </div>
      </div>

      <!--information-->
      <div class="information clearfix">
        <!--left-->
        <div class="info_area info_left info_content">
          <story :myStory="myStory" :jobs="jobsDesc"></story>
          <projects :projects="projects"></projects>
        </div>

        <!--right-->
        <div class="info_area info_right info_timeline">
          <timeline :jobs="jobs"></timeline>
          <h5>My skill point</h5>
          <skills v-for="skill in skills" :icon="skill.icon" :category="skill.category" :languages="skill.languages" :key="skill.category"></skills>
        </div>
      </div>

    </div>
  </div>

  <div class="footer clearfix"></div>

  <!--Personal Information-->
  <div class="tip_avatar">
      <a href="javascript:;" class="tip_close" aria-hidden="true" data-icon="M"></a>
      <div class="tip_avatar_con">
          <div class="tip_right">
              <p class="en mt">Hello my name is</p>
              <h2>Brandon Pinto</h2>
              <p>Learning / engaged in the industry</p>
              <p class="mt20">Contact information</p>
              <p><i aria-hidden="true" class="icon_mail_alt"></i>brandonpinto91.bp@gmail.com</p>
              <p><i aria-hidden="true" class="icon_mobile"></i>706-372-1749</p>
          </div>

      </div>
  </div>
  <div class="tip_avatar_bg"></div>
</app>
</template>

<<script>
import App from './App'
import Story from './Story'
import Projects from './Projects'
import Timeline from './Timeline'
import Skills from './Skills'
import {skills, projects, jobs, myStory, jobsDesc} from '../data'
export default {
  name: 'resume',
  components: { App, Story, Projects, Timeline, Skills },
  data () {
    return {
      skills: skills,
      projects: projects,
      jobs: jobs,
      myStory: myStory,
      jobsDesc: jobsDesc
    }
  }
}
</script>

<<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Resume.vue